import {
  BlockWebform,
} from '../implementations';

const mappers = {
  webform: BlockWebform,
};

export default mappers;
